import { supabase } from '../lib/supabase';

export interface Frame {
  id: number;
  gameId: number;
  playerAFinalScore: number | null;
  playerBFinalScore: number | null;
  created_at: string;
}

// Create a new frame
export const createFrame = async (gameId: number): Promise<Frame> => {
  const { data, error } = await supabase
    .from('frames')
    .insert([{
      gameId: gameId,
      playerAFinalScore: null,
      playerBFinalScore: null
    }])
    .select()
    .single();

  if (error) {
    throw new Error(`Failed to create frame: ${error.message}`);
  }

  return data;
};

// Get frames for a game
export const getFramesByGame = async (gameId: number): Promise<Frame[]> => {
  const { data, error } = await supabase
    .from('frames')
    .select('*')
    .eq('gameId', gameId)
    .order('created_at', { ascending: true });

  if (error) {
    throw new Error(`Failed to get frames: ${error.message}`);
  }

  return data || [];
};

// Update frame scores
export const updateFrame = async (id: number, updates: Partial<Frame>): Promise<Frame> => {
  const { data, error } = await supabase
    .from('frames')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    throw new Error(`Failed to update frame: ${error.message}`);
  }

  return data;
};
